export default __webpack_public_path__ + "static/media/Bullet 01.355ae24b.webp";